export default () => ({
  certificate: JSON.parse(localStorage.getItem('singItemAutentic')) || {},
  attendanceFormModules: {},
  selectedForm: null,
  canEdit: true,
  customFormEdit: false,
  attendance: null,
  preConsultation: null,
  exam: null,
  loading: false,
  cidConsultation: null,
  bvConsultation: null,
  form: {},
  selected: null,
  docs: [],
  exams: [],
  isOculosImporting: false,
  savingMedicalRecord: false,
  savingMedicalRecordError: null,
  savedMedicalRecordTypes: new Set(),
  // Snapshot do valor efetivamente PERSISTIDO por tipo de prontuário.
  // Semeado em setAttendance (dados do servidor) e atualizado só após um PUT
  // bem-sucedido. É a fonte de verdade da idempotência do updateMedicalRecord —
  // NÃO usar state.attendance.medicalRecords, que é mutado de forma otimista
  // pelas mutations updateMedicalRecord/updateFormValue antes do PUT e causaria
  // falso positivo (óculos não salva após sincronia refração→óculos).
  persistedMedicalRecordValues: {}
})
